
// import React from "react";
// import { useNavigate } from "react-router-dom";

// const services = [
//   {
//     title: "HALI YIKAMA",
//     headingImage: "/images/headings/15.png",
//     image: "/images/services/hali.png",
//     description:
//       "Halı yıkama işleminde, evinizin hijyenini sağlamak ve halılarınızı en uygun yöntemlerle temiz tutmak için profesyonel ekipmanlar kullanılmaktadır. Derinlemesine temizlik sağlayan özel tekniklerle halılarınız ilk günkü parlaklığına kavuşur!",
//     path: "/hali-yikama",
//   },
//   {
//     title: "YORGAN YIKAMA",
//     headingImage: "/images/headings/7.png",
//     image: "/images/services/yorgan.png",
//     description:
//       "Yorgan ve battaniye yıkama, kış aylarında bakteri oluşumunu engellemek açısından çok büyük önem taşır. Profesyonel sistemler ve doğal ürünlerle yapılan yıkama işlemi, yorganlarınızın hem temiz hem de sağlıklı kullanılmasını sağlar.",
//     path: "/yorgan-yikama",
//   },
//   {
//     title: "KURU TEMİZLEME",
//     headingImage: "/images/headings/13.png",
//     image: "/images/services/kuru.png",
//     description:
//       "Kuru temizleme işlemi, çabuk deforme olan hassas kumaşlar için idealdir. Leke çıkarıcı ve formunu koruyucu kimyasallarla yapılan işlemler sayesinde kıyafetlerinizin ömrü uzar ve hijyenik kalır.",
//     path: "/kuru-temizleme",
//   },
//   {
//     title: "KOLTUK YIKAMA",
//     headingImage: "/images/headings/5.png",
//     image: "/images/services/8.png",
//     description:
//       "Koltuk yıkama işlemi, yaşam alanlarınızdaki hijyen seviyesini yükseltir. Derinlemesine temizlik sağlayan makineler sayesinde koltuklarınız hem temiz hem de alerjenlerden arınmış olur.",
//     path: "/koltuk-yikama",
//   },
//   {
//     title: "YERİNDE YIKAMA",
//     headingImage: "/images/headings/10.png",
//     image: "/images/services/9.png",
//     description:
//       "Yerinde yıkama hizmeti; halı, koltuk ve yatak gibi eşyalarınızın bulunduğu yerden alınmadan, özel makinelerle temizlenmesini sağlar. Hijyenik ortam sağlanırken zaman ve iş gücünden tasarruf edilir.",
//     path: "/yerinde-yikama",
//   },
//   {
//     title: "YATAK YIKAMA",
//     headingImage: "/images/headings/6.png",
//     image: "/images/services/yatak.png",
//     description:
//       "Yatak ve battaniye yıkama, kış aylarında bakteri oluşumunu engellemek açısından çok büyük önem taşır. Hijyenik yataklar için profesyonel ekipmanlar ve sağlığa uygun deterjanlarla hizmet verilir.",
//     path: "/yatak-yikama",
//   },
//   {
//     title: "PERDE YIKAMA",
//     headingImage: "/images/headings/8.png",
//     image: "/images/services/10.png",
//     description:
//       "Stor ve zebra perde yıkama işlemleri, evinizin havasını tazeler. Toz, kir ve bakterilerin tamamen arındırılması sağlanır. Perde türüne uygun yıkama teknikleriyle güvenli temizlik sunulur.",
//     path: "/stor-zebra-perde-yikama",
//   },
//   {
//     title: "HALI-OVERLOK",
//     headingImage: "/images/headings/11.png",
//     image: "/images/services/13.png",
//     description:
//       "Halı uçları ve overlik hizmetleri, yıpranan halıların daha estetik görünmesini sağlar. Kenar dikişleriyle halınızın uzun ömürlü kullanımı garanti altına alınır.",
//     path: "/hali-tamir-overlok",
//   },
//   {
//     title: "HALI-TAMİRİ",
//     headingImage: "/images/headings/12.png",
//     image: "/images/services/15.png",
//     description:
//       "Yırtılan halılar ve overlok hizmetleri, yıpranan zemin dokusunu onarmak için büyük önem taşır. Hasarlı bölgelerin profesyonelce onarımı sayesinde halınız tekrar kullanılabilir duruma gelir.",
//     path: "/hali-tamir-overlok",
//   },
// ];

// const ServicesGrid = () => {
//   const navigate = useNavigate();

//   return (
//     <section className="bg-[#f7f7d4] py-12 px-4">
//       <div className="bg-[#f7f7d4] py-10 px-4">
//         <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
//           {services.map((item, index) => (
//             <div
//               key={index}
//               className="bg-white p-4 rounded-xl border border-[#ccc] shadow-md cursor-pointer hover:shadow-lg transition"
//               onClick={() => navigate(item.path)}
//             >
//               {/* Üst başlık görseli */}
//               <div className="flex justify-center mb-3">
//                 <img
//                   src={item.headingImage}
//                   alt={item.title}
//                   className="h-[60px] object-contain"
//                 />
//               </div>

//               {/* Orta görsel */}
//               <div className="mb-4 rounded-md overflow-hidden border border-black/50">
//                 <img
//                   src={item.image}
//                   alt={item.title}
//                   className="w-full h-48 object-cover"
//                 />
//               </div>

//               {/* Açıklama */}
//               <p className="text-[15px] text-gray-900 leading-relaxed text-justify font-[500]">
//                 {item.description}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ServicesGrid;
import React from "react";
import { useNavigate } from "react-router-dom";

const services = [
  {
    title: "HALI YIKAMA",
    headingImage: "/images/headings/15.png",
    image: "/images/services/hali.png",
    width: 715,
    height: 485,
    path: "/hali-yikama",
    description:
      "Halı yıkama işleminde, evinizin hijyenini sağlamak ve halılarınızı en uygun yöntemlerle temiz tutmak için profesyonel ekipmanlar kullanılmaktadır. Derinlemesine temizlik sağlayan özel tekniklerle halılarınız ilk günkü parlaklığına kavuşur!",
  },
  {
    title: "YORGAN YIKAMA",
    headingImage: "/images/headings/7.png",
    image: "/images/services/yorgan.png",
    width: 715,
    height: 485,
    path: "/yorgan-yikama",
    description:
      "Yorgan ve battaniye yıkama, kış aylarında bakteri oluşumunu engellemek açısından çok büyük önem taşır. Profesyonel sistemler ve doğal ürünlerle yapılan yıkama işlemi, yorganlarınızın hem temiz hem de sağlıklı kullanılmasını sağlar.",
  },
  {
    title: "KURU TEMİZLEME",
    headingImage: "/images/headings/13.png",
    image: "/images/services/kuru.png",
    width: 715,
    height: 485,
    path: "/kuru-temizleme",
    description:
      "Kuru temizleme işlemi, çabuk deforme olan hassas kumaşlar için idealdir. Leke çıkarıcı ve formunu koruyucu kimyasallarla yapılan işlemler sayesinde kıyafetlerinizin ömrü uzar ve hijyenik kalır.",
  },
  {
    title: "KOLTUK YIKAMA",
    headingImage: "/images/headings/5.png",
    image: "/images/services/8.png",
    width: 715,
    height: 485,
    path: "/koltuk-yikama",
    description:
      "Koltuk yıkama işlemi, yaşam alanlarınızdaki hijyen seviyesini yükseltir. Derinlemesine temizlik sağlayan makineler sayesinde koltuklarınız hem temiz hem de alerjenlerden arınmış olur.",
  },
  {
    title: "YERİNDE YIKAMA",
    headingImage: "/images/headings/10.png",
    image: "/images/services/9.png",
    width: 715,
    height: 485,
    path: "/yerinde-yikama",
    description:
      "Yerinde yıkama hizmeti; halı, koltuk ve yatak gibi eşyalarınızın bulunduğu yerden alınmadan, özel makinelerle temizlenmesini sağlar. Hijyenik ortam sağlanırken zaman ve iş gücünden tasarruf edilir.",
  },
  {
    title: "YATAK YIKAMA",
    headingImage: "/images/headings/6.png",
    image: "/images/services/yatak.png",
    width: 1024,
    height: 1024,
    path: "/yatak-yikama",
    description:
      "Yatak ve battaniye yıkama, kış aylarında bakteri oluşumunu engellemek açısından çok büyük önem taşır. Hijyenik yataklar için profesyonel ekipmanlar ve sağlığa uygun deterjanlarla hizmet verilir.",
  },
  {
    title: "PERDE YIKAMA",
    headingImage: "/images/headings/8.png",
    image: "/images/services/10.png",
    width: 715,
    height: 485,
    path: "/stor-zebra-perde-yikama",
    description:
      "Stor ve zebra perde yıkama işlemleri, evinizin havasını tazeler. Toz, kir ve bakterilerin tamamen arındırılması sağlanır. Perde türüne uygun yıkama teknikleriyle güvenli temizlik sunulur.",
  },
  {
    title: "HALI-OVERLOK",
    headingImage: "/images/headings/11.png",
    image: "/images/services/13.png",
    width: 384,
    height: 378,
    path: "/hali-tamir-overlok",
    description:
      "Halı uçları ve overlik hizmetleri, yıpranan halıların daha estetik görünmesini sağlar. Kenar dikişleriyle halınızın uzun ömürlü kullanımı garanti altına alınır.",
  },
  {
    title: "HALI-TAMİRİ",
    headingImage: "/images/headings/12.png",
    image: "/images/services/15.png",
    width: 382,
    height: 382,
    path: "/hali-tamir-overlok",
    description:
      "Yırtılan halılar ve overlok hizmetleri, yıpranan zemin dokusunu onarmak için büyük önem taşır. Hasarlı bölgelerin profesyonelce onarımı sayesinde halınız tekrar kullanılabilir duruma gelir.",
  },
];

const ServicesGrid = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-gradient-to-b from-[#1c1c1c] via-[#2a2a2a] to-[#111111] py-16 px-4">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {services.map((item, index) => (
          <div
            key={index}
            onClick={() => navigate(item.path)}
            className="group cursor-pointer overflow-hidden rounded-[28px] border border-[#d6b56d]/30 bg-[#fffaf0] shadow-[0_28px_70px_rgba(0,0,0,0.5)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_35px_90px_rgba(0,0,0,0.7)]"
          >
            {/* Üst */}
            <div className="bg-gradient-to-b from-[#fff7df] to-[#f1dfb8] px-5 py-5 border-b border-[#d6b56d]/40">
              <div className="flex justify-center">
                <img
                  src={item.headingImage}
                  alt={item.title}
                  className="h-[72px] object-contain transition duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Görsel */}
            <div
              className="m-4 overflow-hidden rounded-2xl border border-black/40"
              style={{ aspectRatio: `${item.width} / ${item.height}` }}
            >
              <img
                src={item.image}
                alt={item.title}
                width={item.width}
                height={item.height}
                loading="lazy"
                className="w-full h-full object-cover transition duration-700 group-hover:scale-110"
              />
            </div>

            {/* Açıklama */}
            <div className="px-5 pb-6">
              <p className="text-[15px] leading-relaxed text-[#2b1a12] text-justify font-medium">
                {item.description}
              </p>

              <div className="mt-5 h-[1px] w-full bg-gradient-to-r from-transparent via-[#c59b45] to-transparent" />

              <button className="mt-5 w-full rounded-full bg-gradient-to-r from-[#2f160b] to-[#5a2410] px-5 py-3 text-sm font-bold tracking-wide text-[#f8e6b2] shadow-lg transition group-hover:scale-[1.02]">
                Detaylı Bilgi Al
              </button>
            </div>
          </div>
        ))}

      </div>
    </section>
  );
};

export default ServicesGrid;
